namespace Gordic.Adm.WebControls.BaseForms {
    export function ColorSelectForm(): Gordic.Forms.Form {
        var frm = new Gordic.Forms.Form({
            layoutDescriptor: "L1M1S1",
            customClass: "formSelectColor",
            name: "formSelectColor",
        })
            .addRow("jres:33000053").addField("gradio", { //RC 33000053 : Způsob zadání
                name: "colorSelect",
                defaultValue: "rgb",
                radios: [
                    { value: "rgb", label: "jres:33000057" }, //RC 33000057 : RGB
                    { value: "hexa", label: "jres:33000058" } //RC 33000058 : Hexadecimálně
                ],
                change: (ev, changeObj) => {
                    var formEl = $.content($(ev.target));
                    if (changeObj.value == "rgb") {
                        formEl.findFields("hexa").gfield("option", { disabled: true})
                        formEl.findFields("red").gfield("option", { disabled: false })
                        formEl.findFields("green").gfield("option", { disabled: false })
                        formEl.findFields("blue").gfield("option", { disabled: false })
                    } else {
                        formEl.findFields("hexa").gfield("option", { disabled: false })
                        formEl.findFields("red").gfield("option", { disabled: true })
                        formEl.findFields("green").gfield("option", { disabled: true })
                        formEl.findFields("blue").gfield("option", { disabled: true })
                    }
                }
            })
            .addRow("jres:33000054").addField("gnumberbox", "w-3", { //RC 33000054 : RGB barva
                name: "red",
                defaultValue: 0,
                emptyValue: -1,
                disabled: false,
                validators: [
                    new Gordic.Validators.Range({ min: 0, max: 255, stopping: true }),
                    new Gordic.Validators.Required({ stopping: true })
                ],
                change: (ev, data) => {
                    ConvertColorValue(ev, "rgb");
                }
            })
            .addField("gnumberbox", "w-3", {
                name: "green",
                defaultValue: 0,
                emptyValue: -1,
                disabled: false,
                validators: [
                    new Gordic.Validators.Range({ min: 0, max: 255, stopping: true }),
                    new Gordic.Validators.Required({ stopping: true })
                ],
                change: (ev, data) => {
                    ConvertColorValue(ev, "rgb");
                }
            })
            .addField("gnumberbox", "w-3", {
                name: "blue",
                defaultValue: 0,
                emptyValue: -1,
                disabled: false,
                validators: [
                    new Gordic.Validators.Range({ min: 0, max: 255, stopping: true }),
                    new Gordic.Validators.Required({ stopping: true })
                ],
                change: (ev, data) => {
                    ConvertColorValue(ev, "rgb");
                }
            })
            .addRow("jres:33000055").addField("gstringbox", "w-9", { //RC 33000055 : Hexadecimální hodnota
                name: "hexa",
                disabled: true,
                defaultValue: "#000000",
                validators: [
                    new Gordic.Validators.RegExp({ pattern: "^#([0-9a-fA-F]{6})$", stopping: true }),
                ],
                change: (ev, data) => {
                    ConvertColorValue(ev, "hexa");
                }
            }).addField("gbutton", "w-3", {
                params: {
                    type: "action",
                    action: new GAction({
                        name: "actCountColor",
                        caption: "jres:33000056", //RC 33000056 : Vypočítat
                        run: (ev, ctx) => {
                            var type = $.content($(ev.target)).findFields("colorSelect").gfield("getValue") as "rgb" | "hexa";
                            ConvertColorValue(ev, type);
                        }
                    })
                }
            })
            .addRow().addField("gstaticfield", {
                name: "resultColor",
                defaultValue: { hexa: "#000000", red: 0, green: 0, blue: 0 },
                itemTemplate: (value) => { return Gordic.Adm.Utils.ItemTemplateColorBox(value); }
            })
        return frm;
    }

    function ConvertColorValue(ev: JQueryEventObject, value: "rgb" | "hexa") {
        var formEl = $.content($(ev.target)).findForms("formSelectColor");
        if (formEl.gform("isValid")) {
            var hexaColor = "";
            var r = 0, g = 0, b = 0;
            if (value == "rgb") {
                r = parseInt(formEl.findFields("red").gfield("getValue"));
                var red = Gordic.Adm.Utils.NumberToHex(r);
                g = parseInt(formEl.findFields("green").gfield("getValue"));
                var green = Gordic.Adm.Utils.NumberToHex(g);
                b = parseInt(formEl.findFields("blue").gfield("getValue"));
                var blue = Gordic.Adm.Utils.NumberToHex(b);
                hexaColor = "#{0}{1}{2}".format(red, green, blue)
                formEl.findFields("hexa").gfield("setInitial", hexaColor);
            } else {
                var hexa = Gordic.Adm.Utils.HexToNumber(formEl.findFields("hexa").gfield("getValue"));
                if (hexa != null) {
                    formEl.findFields("red").gfield("setInitial", hexa.r);
                    r = hexa.r;
                    formEl.findFields("green").gfield("setInitial", hexa.g);
                    g = hexa.g;
                    formEl.findFields("blue").gfield("setInitial", hexa.b);
                    b = hexa.b;
                }
                hexaColor = formEl.findFields("hexa").gfield("getValue");
            }
            formEl.findFields("resultColor").gfield("setValue", { hexa: hexaColor, red: r, green: g, blue: b})
        }
    } 

    
}